module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form-item', {
    staticClass: "access-setting",
    attrs: {
      "label": _vm.$t('actions.project.settings.access')
    }
  }, [_c('el-radio-group', {
    attrs: {
      "theme": "info"
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "disabled": _vm.disabled.none,
      "label": "none"
    }
  }, [_c('el-tooltip', {
    attrs: {
      "disabled": !_vm.disabled.none,
      "effect": "dark",
      "content": _vm.disabled.msg,
      "placement": "top"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('actions.project.settings.accessTypes.none')))])])], 1), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "disabled": _vm.disabled.code,
      "label": "code"
    }
  }, [_c('el-tooltip', {
    attrs: {
      "disabled": !_vm.disabled.code,
      "effect": "dark",
      "content": _vm.disabled.msg,
      "placement": "top"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('actions.project.settings.accessTypes.code')))])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "access-content"
  }, [(_vm.type === 'none') ? _c('div', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "hint"
  }, [_vm._v(_vm._s(_vm.$t('hint.project.edit.access.none')))])]) : _vm._e(), _vm._v(" "), (_vm.type === 'code') ? _c('div', {
    staticClass: "code"
  }, [_c('el-form', {
    staticClass: "sub-form",
    attrs: {
      "label-position": "top"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('actions.project.settings.accessLabels.code')
    }
  }, [_c('el-input', {
    attrs: {
      "readonly": _vm.disabled.code,
      "placeholder": _vm.$t('placeholder.project.auth_config.code')
    },
    model: {
      value: (_vm.config.code),
      callback: function($$v) {
        _vm.config.code = $$v
      },
      expression: "config.code"
    }
  }, [_c('el-button', {
    staticClass: "random-code-btn",
    on: {
      "click": function($event) {
        _vm.randomCode('code')
      }
    },
    slot: "append"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('actions.project.settings.accessLabels.random')) + "\n            ")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('actions.project.settings.accessLabels.hint')
    }
  }, [_c('el-input', {
    attrs: {
      "readonly": _vm.disabled.code,
      "placeholder": _vm.$t('placeholder.project.auth_config.hint')
    },
    model: {
      value: (_vm.config.hint),
      callback: function($$v) {
        _vm.config.hint = $$v
      },
      expression: "config.hint"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('actions.project.settings.accessLabels.previewPages')
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": _vm.disabled.code,
      "min": 0,
      "max": _vm.project.total_pages
    },
    model: {
      value: (_vm.config.preview_pages),
      callback: function($$v) {
        _vm.config.preview_pages = $$v
      },
      expression: "config.preview_pages"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.type === 'pay') ? _c('div', {
    staticClass: "pay"
  }, [_c('el-form', {
    staticClass: "sub-form",
    attrs: {
      "label-position": "top"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "1"
    }
  }, [_c('span', {
    slot: "label"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('actions.project.settings.accessLabels.price')) + "\n                "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://mp.weixin.qq.com/s/cyI_HAJp0P_fXOFHxZ_cdA"
    }
  }, [_c('i', {
    staticClass: "ppj-icon-help-circled"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "el-input",
    staticStyle: {
      "width": "180px"
    }
  }, [_c('vue-numeric', {
    staticClass: "el-input__inner",
    attrs: {
      "read-only": _vm.disabled.pay,
      "precision": 2,
      "currency": "￥"
    },
    model: {
      value: (_vm.price),
      callback: function($$v) {
        _vm.price = $$v
      },
      expression: "price"
    }
  })], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('actions.project.settings.accessLabels.previewPages')
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": _vm.disabled.pay,
      "min": 0,
      "max": _vm.project.total_pages
    },
    model: {
      value: (_vm.config.preview_pages),
      callback: function($$v) {
        _vm.config.preview_pages = $$v
      },
      expression: "config.preview_pages"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.type === 'spell') ? _c('div', {
    staticClass: "spell"
  }, [_c('el-form', {
    staticClass: "sub-form",
    attrs: {
      "label-position": "top"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('actions.project.settings.accessLabels.code')
    }
  }, [_c('el-input', {
    attrs: {
      "readonly": _vm.disabled.spell,
      "placeholder": _vm.$t('placeholder.project.auth_config.code')
    },
    model: {
      value: (_vm.config.code),
      callback: function($$v) {
        _vm.config.code = $$v
      },
      expression: "config.code"
    }
  }, [_c('el-button', {
    staticClass: "random-code-btn",
    on: {
      "click": function($event) {
        _vm.randomCode('spell')
      }
    },
    slot: "append"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('actions.project.settings.accessLabels.random')) + "\n            ")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "1"
    }
  }, [_c('span', {
    slot: "label"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('actions.project.settings.accessLabels.wechat')) + "\n                "), _c('a', {
    on: {
      "click": _vm.wechatTips
    }
  }, [_c('i', {
    staticClass: "ppj-icon-help-circled"
  })])]), _vm._v(" "), _c('el-input', {
    attrs: {
      "readonly": _vm.disabled.spell,
      "placeholder": _vm.$t('placeholder.project.auth_config.wechat')
    },
    model: {
      value: (_vm.config.wechat),
      callback: function($$v) {
        _vm.config.wechat = $$v
      },
      expression: "config.wechat"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "1"
    }
  }, [_c('span', {
    slot: "label"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('actions.project.settings.accessLabels.spell')) + "\n              "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://mp.weixin.qq.com/s?__biz=MzAxNTc4NjY1NA==&mid=100000024&idx=1&sn=5433384086766586e47833b99260eadb&chksm=1bfff6e92c887fffad42d48ce2cc399796e31316ec85987f5d88f3692ba5e4790137ef9377be&mpshare=1&scene=23&srcid=11220bkdzdzMRr0b2hCt41Fs#rd"
    }
  }, [_c('i', {
    staticClass: "ppj-icon-help-circled"
  })])]), _vm._v(" "), _c('el-input', {
    attrs: {
      "readonly": _vm.disabled.spell,
      "placeholder": _vm.$t('placeholder.project.auth_config.spell')
    },
    model: {
      value: (_vm.config.wechat_spell),
      callback: function($$v) {
        _vm.config.wechat_spell = $$v
      },
      expression: "config.wechat_spell"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('actions.project.settings.accessLabels.previewPages')
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": _vm.disabled.spell,
      "min": 0,
      "max": _vm.project.total_pages
    },
    model: {
      value: (_vm.config.preview_pages),
      callback: function($$v) {
        _vm.config.preview_pages = $$v
      },
      expression: "config.preview_pages"
    }
  })], 1)], 1)], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16ff49b6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/project/show/setting/form/access.card.vue
// module id = 898
// module chunks = 3